<div class="gradientSec">
  <div id="textImgRow" class="row">
      <div id="sideImgText" class="col-6">
          <h4 id="leftTitle" class="title inverted font-extrabold">Free and instant discounts.</h4>
          <p class="ptext font-bold" style="font-size: 18px;">Why choose cloudigo?</p>
          <mat-list role="list" paint="#ffffff">
            @for(feature of features; track feature){
              <mat-list-item role="listitem">
                <mat-icon matListItemIcon>check_circle</mat-icon>
                <span matListItemTitle>{{feature}}</span>
              </mat-list-item>
            }
          </mat-list>
          <div class="store-ctas">
            <a href="https://play.google.com/store/apps/details?id=app.cloudigo.cloudigo" target="_blank">
                <img src="old/playstore-btn.png" alt="Get cloudigo on the playstore"/>
            </a>
            <a href="https://apps.apple.com/mt/app/cloudigo/id1440612925" target="_blank">
                <img src="old/appstore-btn.png" alt="Get cloudigo on the appstore"/>
            </a>
        </div>
      </div>
      <div class="col-6 imgCol">
          <img class="sideImg" src="old/homev2/signupImg.webp" alt="App on Phone"/>
      </div>
  </div>
</div>